module.exports = __webpack_public_path__ + "img/qilin-f-stage3-sulking.36d1e66c.png";